<template>
  <v-dialog
    v-model="show"
    max-width="800"
    persistent
    style="overflow: auto"
    :fullscreen="this.$vuetify.breakpoint.xs"
    id="print-promotion-dialog"
  >
    <v-card>
      <v-row class="pa-2 ma-0">
        <v-card-title class="justify-center display-3 font-weight-bold">{{
          this.$t("title.activate_promotion")
        }}</v-card-title>
        <v-spacer></v-spacer>
        <v-btn class="text-right" icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-row align="center" class="pa-2 ma-0">
        <v-col><canvas id="promotion-qr"></canvas></v-col>
        <v-col class="text-center display-2 font-weight-light">
          <span class="display-3" style="font-weight: bold">{{
            chosenPromotion.title
          }}</span>
          <div>
            {{
              this.$t("message.print_promotion_dialog", {
                organization_name: this.$store.state.config.name
              })
            }}
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="pa-1">
          <v-row class="text-center">
            <v-col
              ><v-btn color="primary" @click="downloadCanvas('promotion-qr')">{{
                this.$t("button.download")
              }}</v-btn></v-col
            >
            <v-col>
              <v-btn text color="primary" @click="printCanvas('promotion-qr')">
                {{ this.$t("button.print") }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PrintPromotionDialog",
  props: ["chosen_promotion", "value"],
  mounted() {
    this.chosenPromotion = this.chosen_promotion;
  },
  updated() {
    this.setCanvas();
  },
  data() {
    return {
      chosenPromotion: { item: {}, campaign: { loyalty_system: {} } }
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    show: function(val) {
      if (val) {
        //setting qr
        this.chosenPromotion = this.chosen_promotion;
      }
    }
  },
  methods: {
    downloadCanvas(id) {
      let link = document.createElement("a");
      let kebabCaseTitle = this.chosenPromotion.title
        .replace(/[^a-zA-Z0-9_.]/g, "-")
        .replace(/^-+|-+$/g, "")
        .toLowerCase();
      link.download = `${kebabCaseTitle}.png`;
      link.href = document.getElementById(id).toDataURL();
      link.click();
    },
    async printCanvas(id) {
      let src = document.getElementById(id).toDataURL("image/png");
      let newWindow = window.open("", "_blank");
      newWindow.document.write(
        `
<!DOCTYPE html>
<html>
<head>
  <style>
    .container {
      display: flex;
      width: 100%;
    }

    .box {
      width: 50%;
      height: 310px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .right-box {
      padding: 20px;
      flex-direction: column;
      text-align: center;
    }

    h4 {
      margin: 0;
    }
  </style>
</head>
<body>
  <div class="container">
    <div class="box">
      <img id="qr-code" src="` +
          src +
          `" alt="` +
          this.chosenPromotion.title +
          `"/>
    </div>
    <div class="box right-box">
      <h4>` +
          this.chosenPromotion.title +
          `</h4>
      <p>
        ` +
          this.$t("message.print_promotion_dialog", {
            organization_name: this.$store.state.config.name
          }) +
          `
      </p>
    </div>
  </div>
</body>
</html>
      `
      );
      newWindow.document.title = this.chosenPromotion.title;
      const printImage = newWindow.document.getElementById("qr-code");
      printImage.onload = function() {
        newWindow.print();
      };
      newWindow.document.close();
    },
    setCanvas() {
      let QRCode = require("qrcode");
      let canvas = document.getElementById("promotion-qr");
      if (this.chosenPromotion.user_promotions.length === 0) {
        return;
      }
      QRCode.toCanvas(
        canvas,
        this.chosenPromotion.user_promotions[0].barcode,
        { width: 300, errorCorrectionLevel: "H" },
        function() {}
      );
    }
  }
};
</script>

<style scoped></style>
